// extracted by mini-css-extract-plugin
var _1 = "webpack-components-Badge-Badge-module__badge";
var _2 = "webpack-components-Badge-Badge-module__badge--large";
var _3 = "webpack-components-Badge-Badge-module__badge--medium";
var _4 = "webpack-components-Badge-Badge-module__badge--muted";
var _5 = "webpack-components-Badge-Badge-module__badge--primary";
var _6 = "webpack-components-Badge-Badge-module__badge--success";
var _7 = "webpack-components-Badge-Badge-module__badge--warn";
export { _1 as "badge", _2 as "badge--large", _3 as "badge--medium", _4 as "badge--muted", _5 as "badge--primary", _6 as "badge--success", _7 as "badge--warn" }
